export default "__VITE_ASSET__0bf0ae30__"